import { IRootState } from "store";
import { Middleware } from "redux";
import { NAVIGATION_CHANGED } from 'store/modules/navigation/actions'
import { EMAIL_CONFIRMED, LOGOUT } from 'store/modules/authentication/actions'
import { APPLICATION_INITIALIZED } from "store/modules/application/actions";
import * as API from 'api'
import { LOAD_USER_INFO_SUCCESS, LOAD_USER_INFO_FAIL } from "store/modules/user/actions";

export const analyticsMiddleWare: Middleware = ({ getState }: { getState: () => IRootState }) => next => action => {

    // dispatch the action 1st
    next(action);
    const { user } = getState();
    switch (action.type) {
        case LOAD_USER_INFO_SUCCESS:
            API.Analytics.trackUserInfo(user.id);
            break;
        case LOAD_USER_INFO_FAIL:
        case LOGOUT:
            API.Analytics.logout();
            break;
        case APPLICATION_INITIALIZED:
        case NAVIGATION_CHANGED:
            API.Analytics.pageVisited();
            break;
        case EMAIL_CONFIRMED:
            API.Analytics.emailConfirmed(user.email);
            break;
    }
}


// WEBPACK FOOTER //
// ./src/application/middleware/analytics.ts